







import { Component, mixins } from '@niknevis/vue-modules'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import { InjectReactive } from 'vue-property-decorator'
import TextWrapper from '@/modules/shared/components/shared/TextWrapper.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import { WalletLogType } from '@/modules/wallet-log/models/admin-wallet-log-resource.model'

@Component({
  components: {
    TesTr
  }
})
export default class AdminUserWalletLogTableRow extends mixins(TesTableRow) {
  @InjectReactive() fixedData

  columnComponents = {
    description: {
      component: TextWrapper,
      handler: value => ({ text: value })
    },
    type: {
      component: TextWrapper,
      handler: (value, row, fixedData) => ({
        text: fixedData.types[value],
        class: ['row justify-center', value === WalletLogType.INC ? 'text-tes-green' : 'text-tes-red']
      })
    },
    author: {
      component: AdminUserInfoButton,
      handler: value => ({ basicUser: value, asText: true })
    },
    created_at: {
      component: DateTooltipped,
      handler: value => ({ isoDate: value, defaultText: value })
    }
  }
}
